import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get_missed_rx3x4x, driver_emergency_prepared_rx } from "../../../networking/urlEndPoints";
import Axios from "../../../networking/interceptor";

export const fetchMissedRx3x4x = createAsyncThunk('fetchMissedRx3x4x', async (requesteData, { rejectWithValue }) => {
    const { page, pharmacy_id, setLoading, setLoadMore, dispatch, patient_id } = requesteData;

    try {
        const params = {
            page,
            pharmacy_id,
        }
        const response = await Axios.get(get_missed_rx3x4x, { params })
        const data = response.data
        if (typeof setLoading === 'function') {
            setLoading(false)
        }

        if (patient_id) {
            dispatch(removeMissedRx3x4xById(patient_id));
        }

        if (typeof setLoadMore === 'function') {
            setLoadMore(false)
        }

        return data;

    } catch (error) {
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
        return rejectWithValue(error.response)
    }
});

export const fetchEmergencyPreparedRx = createAsyncThunk('fetchEmergencyPreparedRx', async (requesteData, { rejectWithValue }) => {
    const { pharmacy_id, setLoading } = requesteData;

    try {
        const params = { pharmacy_id };
        const response = await Axios.get(driver_emergency_prepared_rx, { params })
        const data = response.data
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
        return data;
    } catch (error) {
        if (typeof setLoading === 'function') {
            setLoading(false)
        }
        return rejectWithValue(error.response)
    }
});

const initialState = {
    loading: false,
    data: [],
    error: null,
    currentPage: 1,
    totalPages: null,
    emergenciesLoading: false,
    emergenciesData: [],
    emergenciesError: null
}

const missedRx3x4xSlice = createSlice({
    name: 'missedRx3x4x',
    initialState,

    reducers: {
        removeMissedRx3x4xById(state, action) {
            const missedRxIdToRemove = action.payload;
            state.data = state.data.filter(item => item.id !== missedRxIdToRemove);
        },
        clearData(state) {
            state.data = []
        },
        missedRx3x4xRemovingPageNumber(state) {
            state.currentPage = 1
        }
    },

    extraReducers: (builder) => {
        builder.addCase(fetchMissedRx3x4x.pending, (state) => {
            return {
                ...state,
                loading: true,
                error: null,
                data: []
            }
        })
        builder.addCase(fetchMissedRx3x4x.fulfilled, (state, action) => {
            const existingIds = new Set(state?.data?.map(item => item.id));
            const newData = action?.payload?.data?.filter(item => !existingIds.has(item.id));

            return {
                ...state,
                loading: false,
                data: [...state.data, ...newData],
                currentPage: action.payload.meta?.current_page || 1,
                totalPages: action.payload.meta?.last_page || 1,
                error: null
            };
        });

        builder.addCase(fetchMissedRx3x4x.rejected, (state, action) => {
            return {
                ...state,
                loading: false,
                error: action.payload,
                data: []
            }
        })
        builder.addCase(missedRx3x4xSlice.actions.removeMissedRx3x4xById, (state, action) => {
            const missedRxIdToRemove = action.payload;
            state.data = state.data.filter(item => item.id !== missedRxIdToRemove);
        });

        // Emergencies list builders
        builder.addCase(fetchEmergencyPreparedRx.pending, (state) => {
            return {
                ...state,
                emergenciesLoading: true,
                emergenciesError: null,
                emergenciesData: []
            }
        })
        builder.addCase(fetchEmergencyPreparedRx.fulfilled, (state, action) => {
            return {
                ...state,
                emergenciesLoading: false,
                emergenciesData: action?.payload?.data || [],
                emergenciesError: null
            };
        });
        builder.addCase(fetchEmergencyPreparedRx.rejected, (state, action) => {
            return {
                ...state,
                emergenciesLoading: false,
                emergenciesError: action.payload,
                emergenciesData: []
            }
        })
    }

})

export const { removeMissedRx3x4xById, clearData, missedRx3x4xRemovingPageNumber } = missedRx3x4xSlice.actions;

export default missedRx3x4xSlice.reducer;
